import React from 'react';

function safeToString(val) {
  if (val == null) return '-';
  if (typeof val === 'string' || typeof val === 'number') return val;
  if (Array.isArray(val)) return '[array]';
  if (typeof val === 'object' && val.$$typeof) return '[elemento React]';
  if (typeof val === 'object' && val.nome) return val.nome;
  if (typeof val === 'object' && val.data) return val.data;
  try {
    return JSON.stringify(val);
  } catch {
    return '[objeto]';
  }
}

const SafeText = ({ value }) => {
  const str = safeToString(value);
  if (typeof value === 'object' && value !== null) {
    // Log para debug global
    // eslint-disable-next-line no-console
    console.warn('SafeText: valor inesperado recebido:', value);
  }
  return <>{str}</>;
};

export default SafeText;
